/* ============================================================
   LW24 Bundle Builder v4 — Inline Drawer + Mini-Cart + Surcharge-Grouping
   Vanilla JS, no deps

   v4 (2026-04-15):
   - FIX: Mini-Cart gruppiert Surcharge-Line-Items (XL +15€, Outdoor +10€)
     unter ihre zugeordnete Main-Lampe. Vorher wurden Surcharges als
     eigene Zeile "Aufpreis: Premium XL — 15,00 €" gerendert.
   - Main-Lampe zeigt jetzt Variant-Label aus Properties "Größe" /
     "Verwendung" (z.B. "Premium XL 32cm · Draußen") wenn aus Cart-Drawer-
     Upsell addiert. Fallback: Shopify variant_title.
   - Line-Price der Main-Lampe enthält jetzt die zugeordneten Surcharge-
     Preise (visuelles Total pro Lampe).
   ============================================================ */
(function () {
  'use strict';

  /* Stufen am 10.09.2026 am Live-Warenkorb nachgemessen (Rezept im Kopf von
     snippets/lw-bundle-tier-logic.liquid). */
  var TIERS = [
    { qty: 2, discount: 0.10, label: '−10%' },
    { qty: 3, discount: 0.15, label: '−15%' },
    { qty: 4, discount: 0.25, label: '−25%' },
    { qty: 5, discount: 0.28, label: '−28%' }
  ];
  var MAX_QTY = 5;
  var BUNDLE_PROP_KEY = '_bundle';
  var BUNDLE_ID_KEY   = '_bundle_id';

  /* Surcharge-Variant-IDs — müssen exakt zu main-product.liquid + v24 passen */
  var SURCH_XL_ID       = 53955374088532;
  var SURCH_OUTDOOR_ID  = 53957538677076;

  function isSurchargeItem(item) {
    if (!item) return false;
    return item.variant_id === SURCH_XL_ID || item.variant_id === SURCH_OUTDOOR_ID;
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  function fmtPrice(cents, currency) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || 'EUR' })
        .format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2) + ' €';
    }
  }
  function parseJSON(el) {
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function uuid() {
    return 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }
  function escHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  /**
   * v4 NEU: Surcharge-Gruppierung analog zu v24.buildGroups().
   * Filtert Surcharge-Items raus und packt deren Preise + Labels
   * auf die zugehörige Main-Lampe (matcht über Property-Regex).
   */
  function buildGroupedBundleItems(cartItems) {
    if (!cartItems || !cartItems.length) return [];
    var mains = [];
    var surchXL = null;      // erste XL-Surcharge-Line
    var surchOut = null;     // erste Outdoor-Surcharge-Line
    cartItems.forEach(function (it) {
      if (!it) return;
      if (it.variant_id === SURCH_XL_ID) { if (!surchXL) surchXL = it; return; }
      if (it.variant_id === SURCH_OUTDOOR_ID) { if (!surchOut) surchOut = it; return; }
      mains.push(it);
    });

    return mains.map(function (main) {
      var props = main.properties || {};
      var qty = main.quantity || 1;
      var extraPrice = 0;
      var variantBits = [];

      var hasXL = props['Größe'] && /premium/i.test(props['Größe']);
      var hasOutdoor = props['Verwendung'] && /drau/i.test(props['Verwendung']);

      /* Basis-Variant-Label: Property > variant_title > Fallback */
      var baseLabel = '';
      if (hasXL) {
        baseLabel = 'L 32 cm';
      } else if (main.variant_title && main.variant_title !== 'Default Title') {
        baseLabel = main.variant_title;
      } else if (main.options_with_values && main.options_with_values.length) {
        var vals = main.options_with_values
          .map(function (o) { return o && o.value; })
          .filter(function (v) { return v && v !== 'Default Title'; });
        if (vals.length) baseLabel = vals.join(' · ');
      }

      if (baseLabel) variantBits.push(baseLabel);
      if (hasOutdoor) variantBits.push('Draußen');

      if (hasXL && surchXL) {
        /* Anteiliger XL-Surcharge-Preis pro Main-Qty */
        var xlPerUnit = (surchXL.price || 1500);
        extraPrice += xlPerUnit * qty;
      }
      if (hasOutdoor && surchOut) {
        var outPerUnit = (surchOut.price || 1000);
        extraPrice += outPerUnit * qty;
      }

      var mainLinePrice = main.line_price != null ? main.line_price : (main.price || 0) * qty;
      var displayLinePrice = mainLinePrice + extraPrice;

      return {
        image: main.image || main.featured_image || '',
        quantity: qty,
        title: main.product_title || main.title || '',
        variantLabel: variantBits.join(' · '),
        linePrice: displayLinePrice
      };
    });
  }

  function initBundle(root) {
    if (root.__lwInit) return;
    root.__lwInit = true;

    var productId = root.dataset.productId;
    var currency  = root.dataset.currency || 'EUR';
    var variants  = parseJSON($('[data-lw-variants]', root)) || [];
    var options   = parseJSON($('[data-lw-options]',  root)) || [];

    var state = {
      bundleId: sessionStorage.getItem('lw_bundle_id_' + productId) || uuid(),
      cartQty: 0,
      cartItems: [],
      cartTotal: 0,
      cartDiscount: 0,
      cartSubtotal: 0,
      selectedMotiv: null,
      selectedVariantId: null,
      selectedOptions: {},
      isAdding: false,
      isOpen: false
    };
    sessionStorage.setItem('lw_bundle_id_' + productId, state.bundleId);

    var refs = {
      title:       $('[data-lw-title]', root),
      sub:         $('[data-lw-sub]', root),
      ctaBtn:      $('[data-lw-toggle]', root),
      ctaLabel:    $('[data-lw-cta-label]', root),
      savings:     $('[data-lw-savings]', root),
      ladder:      $$('[data-rung]', root),
      progressBar: $('[data-lw-progress-bar]', root),
      max:         $('[data-lw-max]', root),
      drawer:      $('[data-lw-drawer]', root),
      drawerSub:   $('[data-lw-drawer-sub]', root),
      drawerPrice: $('[data-lw-drawer-price]', root),
      grid:        $('[data-lw-grid]', root),
      optsWrap:    $('[data-lw-opts]', root),
      addBtn:      $('[data-lw-add]', root),
      mini:            $('[data-lw-mini]', root),
      miniTitle:       $('[data-lw-mini-title]', root),
      miniHint:        $('[data-lw-mini-hint]', root),
      miniList:        $('[data-lw-mini-list]', root),
      miniTotal:       $('[data-lw-mini-total]', root),
      miniTotalPrice:  $('[data-lw-mini-total-price]', root),
      miniTotalSaved:  $('[data-lw-mini-total-saved]', root)
    };

    function nextTier() {
      var nextQty = state.cartQty + 1;
      for (var i = 0; i < TIERS.length; i++) {
        if (TIERS[i].qty >= nextQty) return TIERS[i];
      }
      return null;
    }
    function currentTier() {
      var reached = null;
      for (var i = 0; i < TIERS.length; i++) {
        if (state.cartQty >= TIERS[i].qty) reached = TIERS[i];
      }
      return reached;
    }

    function render() {
      refs.ladder.forEach(function (r) {
        var q = parseInt(r.dataset.rung, 10);
        r.removeAttribute('data-reached');
        if (state.cartQty >= q) r.setAttribute('data-reached', 'true');
      });

      var pct = Math.min(100, (state.cartQty / MAX_QTY) * 100);
      if (refs.progressBar) refs.progressBar.style.width = pct + '%';

      if (state.cartQty >= MAX_QTY) {
        refs.max.hidden = false;
        refs.ctaBtn.hidden = true;
        refs.title.textContent = 'Bundle komplett, 28% gespart!';
        refs.sub.textContent = 'Du hast den maximalen Rabatt erreicht. Weiter zur Kasse.';
        if (refs.savings) refs.savings.hidden = true;
        closeDrawer();
      } else {
        refs.max.hidden = true;
        refs.ctaBtn.hidden = false;

        var tier = nextTier();
        if (tier) {
          if (state.cartQty === 0) {
            refs.title.innerHTML = 'Füge eine 2. Lampe hinzu &amp; spare ' + Math.round(tier.discount * 100) + '%';
            refs.sub.textContent = 'Kombiniere Motive frei — je mehr du wählst, desto höher dein Rabatt.';
            refs.ctaLabel.textContent = 'Motiv wählen & sparen';
          } else {
            var nextCount = state.cartQty + 1;
            refs.title.innerHTML = 'Wähle deine ' + nextCount + '. Lampe &amp; spare ' + Math.round(tier.discount * 100) + '%';
            refs.sub.textContent = 'Noch ein Motiv dazu — rabattiert wird automatisch im Warenkorb.';
            refs.ctaLabel.textContent = 'Nächstes Motiv wählen';
          }
          if (refs.drawerSub) {
            refs.drawerSub.textContent = (state.cartQty + 1) + '. Lampe — spare ' + Math.round(tier.discount * 100) + '%';
          }
        }
      }

      var reached = currentTier();
      if (reached && refs.savings) {
        refs.savings.hidden = false;
        refs.savings.textContent = 'Aktueller Bundle-Rabatt: ' + reached.label;
      } else if (refs.savings) {
        refs.savings.hidden = true;
      }

      renderMiniCart();
    }

    function renderMiniCart() {
      if (!refs.mini) return;
      if (!state.cartItems || state.cartItems.length === 0) {
        refs.mini.hidden = true;
        return;
      }
      refs.mini.hidden = false;

      /* v4: state.cartQty zählt nur non-surcharge Items (Lampen-Count) */
      var count = state.cartQty;
      refs.miniTitle.textContent = 'Dein Bundle (' + count + ' Lampe' + (count === 1 ? '' : 'n') + ')';

      var tier = nextTier();
      if (tier && count < MAX_QTY) {
        var more = tier.qty - count;
        refs.miniHint.textContent = 'Noch ' + more + ' Lampe' + (more === 1 ? '' : 'n') + ' für ' + tier.label + ' Rabatt';
      } else if (count >= MAX_QTY) {
        refs.miniHint.textContent = 'Maximaler Rabatt erreicht';
      } else {
        refs.miniHint.textContent = '';
      }

      /* v4: Surcharges filtern + Properties auf Main-Item mappen */
      var grouped = buildGroupedBundleItems(state.cartItems);

      var listHtml = grouped.map(function (g) {
        var qtyPrefix = g.quantity > 1 ? g.quantity + '× ' : '';
        return '<li class="lw-bundle__mini-item">' +
          '<span class="lw-bundle__mini-thumb">' +
            (g.image ? '<img src="' + escHtml(g.image) + '" alt="' + escHtml(g.title) + '" loading="lazy">' : '') +
          '</span>' +
          '<div class="lw-bundle__mini-body">' +
            '<span class="lw-bundle__mini-itemtitle">' + qtyPrefix + escHtml(g.title) + '</span>' +
            (g.variantLabel ? '<span class="lw-bundle__mini-itemvariant">' + escHtml(g.variantLabel) + '</span>' : '') +
          '</div>' +
          '<span class="lw-bundle__mini-itemprice">' + fmtPrice(g.linePrice, currency) + '</span>' +
        '</li>';
      }).join('');
      refs.miniList.innerHTML = listHtml;

      /* Total direkt aus Shopify Cart (keine eigene Rechnung) */
      var net   = state.cartTotal;
      var saved = state.cartDiscount;

      refs.miniTotal.hidden = false;
      refs.miniTotalPrice.textContent = fmtPrice(net, currency);
      if (saved > 0) {
        refs.miniTotalSaved.textContent = '(' + fmtPrice(saved, currency) + ' gespart)';
      } else {
        refs.miniTotalSaved.textContent = '';
      }
    }

    function refreshCart() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          /* v4: cartQty zählt nur Lampen (non-surcharge) damit Tier-Logik stimmt */
          var qty = 0;
          (cart.items || []).forEach(function (it) {
            if (!isSurchargeItem(it)) qty += it.quantity || 0;
          });
          state.cartQty      = qty;
          state.cartItems    = cart.items || [];
          state.cartTotal    = cart.total_price || 0;
          state.cartDiscount = cart.total_discount || 0;
          state.cartSubtotal = cart.items_subtotal_price || cart.original_total_price || 0;
          render();
          return cart;
        })
        .catch(function () { render(); });
    }

    function openDrawer() {
      if (state.isOpen) return;
      state.isOpen = true;
      refs.drawer.setAttribute('aria-hidden', 'false');
      refs.drawer.setAttribute('data-open', 'true');
      refs.ctaBtn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        refs.drawer.style.maxHeight = refs.drawer.scrollHeight + 'px';
      });
      setTimeout(function () {
        var rect = refs.ctaBtn.getBoundingClientRect();
        if (rect.top < 80 || rect.bottom > window.innerHeight - 100) {
          refs.ctaBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
      resetDrawerSelection();
    }

    function closeDrawer() {
      if (!state.isOpen) return;
      state.isOpen = false;
      refs.drawer.style.maxHeight = refs.drawer.scrollHeight + 'px';
      requestAnimationFrame(function () {
        refs.drawer.style.maxHeight = '0px';
      });
      refs.drawer.removeAttribute('data-open');
      refs.drawer.setAttribute('aria-hidden', 'true');
      refs.ctaBtn.setAttribute('aria-expanded', 'false');
    }

    function toggleDrawer() {
      if (state.isOpen) closeDrawer();
      else openDrawer();
    }

    function resetDrawerSelection() {
      state.selectedMotiv = null;
      state.selectedVariantId = null;
      state.selectedOptions = {};
      $$('[data-lw-motiv]', refs.grid).forEach(function (t) { t.setAttribute('aria-checked', 'false'); });
      if (refs.optsWrap) {
        $$('[data-opt-value]', refs.optsWrap).forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          b.removeAttribute('disabled');
        });
      }
      if (refs.drawerPrice) refs.drawerPrice.textContent = '—';
      refs.addBtn.setAttribute('disabled', '');
    }

    function resolveVariant() {
      if (!state.selectedMotiv) return null;
      var selected = [state.selectedMotiv];
      for (var i = 1; i < options.length; i++) {
        if (state.selectedOptions[i] == null) return null;
        selected.push(state.selectedOptions[i]);
      }
      var match = variants.find(function (v) {
        if (!v.available) return false;
        var vals = [v.option1, v.option2, v.option3].slice(0, options.length);
        return vals.every(function (val, idx) { return val === selected[idx]; });
      });
      return match || null;
    }

    function updateOptionButtonAvailability() {
      if (!state.selectedMotiv || !refs.optsWrap) return;
      $$('.lw-bundle__opt', refs.optsWrap).forEach(function (fieldset) {
        var idx = parseInt(fieldset.dataset.optIndex, 10);
        $$('[data-opt-value]', fieldset).forEach(function (btn) {
          var val = btn.dataset.optValue;
          var probe = [state.selectedMotiv];
          for (var i = 1; i < options.length; i++) {
            if (i === idx) probe.push(val);
            else if (state.selectedOptions[i] != null) probe.push(state.selectedOptions[i]);
            else probe.push(null);
          }
          var any = variants.some(function (v) {
            if (!v.available) return false;
            var vals = [v.option1, v.option2, v.option3].slice(0, options.length);
            return vals.every(function (vv, i2) {
              if (probe[i2] == null) return true;
              return vv === probe[i2];
            });
          });
          if (any) btn.removeAttribute('disabled');
          else btn.setAttribute('disabled', '');
        });
      });
    }

    function updateDrawerPrice() {
      var v = resolveVariant();
      if (v) {
        state.selectedVariantId = v.id;
        refs.drawerPrice.textContent = fmtPrice(v.price, currency);
        refs.addBtn.removeAttribute('disabled');
      } else {
        state.selectedVariantId = null;
        refs.drawerPrice.textContent = '—';
        refs.addBtn.setAttribute('disabled', '');
      }
      if (state.isOpen) {
        refs.drawer.style.maxHeight = refs.drawer.scrollHeight + 'px';
      }
    }

    function addToBundle() {
      if (state.isAdding || !state.selectedVariantId) return;
      state.isAdding = true;
      refs.addBtn.classList.add('is-loading');
      refs.addBtn.setAttribute('disabled', '');

      var tier = nextTier();
      var properties = {};
      properties[BUNDLE_PROP_KEY] = 'true';
      properties[BUNDLE_ID_KEY]   = state.bundleId;
      if (tier) properties['_bundle_stufe'] = (state.cartQty + 1) + ' Lampen (' + tier.label + ')';

      var body = {
        items: [{
          id: state.selectedVariantId,
          quantity: 1,
          properties: properties
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (window.PUB_SUB_EVENTS && window.publish) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lw-bundle-builder' });
          }
          return refreshCart();
        })
        .then(function () {
          closeDrawer();
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          else if (drawer) drawer.classList.add('active');
        })
        .catch(function (err) {
          console.error('[LW-Bundle] Add-to-cart failed', err);
          alert('Hinzufügen fehlgeschlagen. Bitte erneut versuchen.');
        })
        .finally(function () {
          state.isAdding = false;
          refs.addBtn.classList.remove('is-loading');
          if (state.selectedVariantId) refs.addBtn.removeAttribute('disabled');
        });
    }

    refs.ctaBtn.addEventListener('click', toggleDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.isOpen) closeDrawer();
    });

    if (refs.max) {
      refs.max.addEventListener('click', function () {
        if (window.LWCartDrawer && typeof window.LWCartDrawer.open === 'function') {
          window.LWCartDrawer.open();
          return;
        }
        var dawn = document.querySelector('cart-drawer');
        if (dawn && typeof dawn.open === 'function') { dawn.open(); return; }
        window.location.href = '/cart';
      });
    }

    if (refs.grid) {
      refs.grid.addEventListener('click', function (e) {
        var tile = e.target.closest('[data-lw-motiv]');
        if (!tile) return;
        $$('[data-lw-motiv]', refs.grid).forEach(function (t) { t.setAttribute('aria-checked', 'false'); });
        tile.setAttribute('aria-checked', 'true');
        state.selectedMotiv = tile.dataset.lwMotiv;
        for (var i = 1; i < options.length; i++) {
          var first = variants.find(function (v) {
            return v.available && v.option1 === state.selectedMotiv;
          });
          if (first) {
            var val = [first.option1, first.option2, first.option3][i];
            state.selectedOptions[i] = val;
          }
        }
        renderOptionSelection();
        updateOptionButtonAvailability();
        updateDrawerPrice();
      });
    }

    if (refs.optsWrap) {
      refs.optsWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-opt-value]');
        if (!btn || btn.hasAttribute('disabled')) return;
        var idx = parseInt(btn.dataset.optIndex, 10);
        state.selectedOptions[idx] = btn.dataset.optValue;
        renderOptionSelection();
        updateOptionButtonAvailability();
        updateDrawerPrice();
      });
    }

    function renderOptionSelection() {
      if (!refs.optsWrap) return;
      $$('.lw-bundle__opt', refs.optsWrap).forEach(function (fs) {
        var idx = parseInt(fs.dataset.optIndex, 10);
        $$('[data-opt-value]', fs).forEach(function (b) {
          b.setAttribute('aria-pressed', state.selectedOptions[idx] === b.dataset.optValue ? 'true' : 'false');
        });
      });
    }

    refs.addBtn.addEventListener('click', addToBundle);

    window.addEventListener('resize', function () {
      if (state.isOpen) {
        refs.drawer.style.maxHeight = refs.drawer.scrollHeight + 'px';
      }
    });

    refreshCart();

    document.addEventListener('cart:refresh', function (e) {
      if (e && e.detail && e.detail.source === 'lw-bundle-builder') return;
      refreshCart();
    });
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (data) {
        if (data && data.source === 'lw-bundle-builder') return;
        refreshCart();
      });
    }
  }

  function boot() {
    $$('[data-lw-bundle]').forEach(initBundle);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();